import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Text,
  Title,
} from "@clipboard-health/ui-components";
import { DEBUG_BASE_PATH } from "@src/appV2/Debug/paths";
import {
  DeploymentEnvironmentName,
  environmentConfig,
  isDevelopmentNodeEnvironment,
} from "@src/appV2/environment";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { isCapacitorPlatform } from "@src/appV2/lib";
import { ACCOUNT_UPDATES_FULL_PATH } from "@src/appV2/redesign/Accounts/paths";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useHistory } from "react-router-dom";

import { logAccountPageMenuItemTapped } from "../utils";

export function AccountsPageTestingSection() {
  const history = useHistory();
  const worker = useDefinedWorker();

  const showDebugPageMenuItemForTesting =
    useCbhFlag(CbhFeatureFlag.SHOW_DEBUG_PAGE_MENU_ITEM_IN_MY_ACCOUNT, { defaultValue: false }) ||
    isDevelopmentNodeEnvironment();

  const showAppUpdatePageMenuItemForTesting =
    isCapacitorPlatform() &&
    (Boolean(worker.isTestAccount) ||
      environmentConfig.REACT_APP_ENVIRONMENT_NAME !== DeploymentEnvironmentName.PRODUCTION);

  return (
    <>
      <Title semibold component="h4">
        Testing
      </Title>

      {showAppUpdatePageMenuItemForTesting && (
        <ListItem divider>
          <ListItemButton
            onClick={() => {
              logAccountPageMenuItemTapped("App Updates");
              history.push(ACCOUNT_UPDATES_FULL_PATH);
            }}
          >
            <ListItemIcon iconType="download" />
            <ListItemText
              primary="App Updates"
              secondary={
                <Text variant="caption" color={(theme) => theme.palette.text.secondary}>
                  Check for and install updates
                </Text>
              }
            />
          </ListItemButton>
        </ListItem>
      )}

      {showDebugPageMenuItemForTesting && (
        <ListItem divider>
          <ListItemButton
            onClick={() => {
              logAccountPageMenuItemTapped("Debug");
              history.push(DEBUG_BASE_PATH);
            }}
          >
            <ListItemIcon iconType="info" />
            <ListItemText
              primary="Debug"
              secondary={
                <Text variant="caption" color={(theme) => theme.palette.text.secondary}>
                  Internal testing
                </Text>
              }
            />
          </ListItemButton>
        </ListItem>
      )}
    </>
  );
}
